import React from "react";
import { DeleteWithConfirmButton, useRecordContext } from "react-admin";

export const HomebaseComponentDeleteButton = props => {
  const record = useRecordContext();
  return (
    <DeleteWithConfirmButton
      confirmContent="Are you sure you want to delete this item?"
      confirmTitle="Delete Homebase Component"
      resource="homebasecomponents"
      record={{ id: record.id }}
      redirect={false}
      mutationMode="pessimistic"
      color="primary"
      style={{ color: "#C90C0F" }}
    />
  );
};
